import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const ConfirmModal = ({ isOpen, toggle, onConfirm, status }) => {
  const isActivate = status !== true;  // If the current status is not "active", we will activate

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Change Status</ModalHeader>
      <ModalBody>
        Are you sure you want to 
        <span className={isActivate ? `text-success text-capitalize` : `text-primary text-capitalize`}>
          {isActivate ? "activate" : "deactivate"}
        </span>
        this?
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={toggle}>
          Cancel
        </Button>
        <Button
          color={isActivate ? "success" : "primary"}
          onClick={() => {
            onConfirm(isActivate);  // Pass the correct status value (true or false)
            toggle();                // Close the modal
          }}
        >
          Yes, {isActivate ? "Activate" : "Deactivate"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmModal;